<template>
  <div>
    <div class="tab-inner-form">
      <div>
        <el-tooltip
          v-if="permission.LAB"
          placement="top">
          <div slot="content">
            <p>1.勾选检测记录</p>
            <p>2.自动根据企业和样品拆分</p>
            <p>3.生成快检报告</p>
          </div>
          <el-button
            type="primary"
            @click="generateinspectionreport">生成报告</el-button>
        </el-tooltip>
      </div>
      <div>
        <ent-auto-select
          v-model="config.vendorId"
          :callback="()=> { handleCurrentChange(1) }" />
        <!-- <el-input
          v-model="config.vendorName"
          clearable
          placeholder="请输入企业名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input> -->
      </div>
    </div>
    <el-table
      ref="table"
      border
      row-key="inspectionItemDataId"
      :data="list"
      max-height="1000px"
      @selection-change="handleSelectionChange">
      <el-table-column
        v-if="permission.LAB"
        type="selection"
        fixed="left"
        reserve-selection
        width="40">
      </el-table-column>
      <!-- <el-table-column
        width="180"
        label="检测记录唯一编号"
        prop="syscode"> </el-table-column>
      <el-table-column
        label="样品编号"
        width="80"
        prop="samplenum"></el-table-column> -->
      <el-table-column
        label="样品名称"
        min-width="120"
        prop="samplename"></el-table-column>
      <!-- <el-table-column
        label="样品种类"
        prop="sampletype"></el-table-column> -->
      <el-table-column
        label="企业名称"
        min-width="170"
        prop="prosecutedunits"></el-table-column>
      <el-table-column
        label="检测项"
        min-width="100"
        prop="testproject"></el-table-column>
      <el-table-column
        min-width="160"
        label="检测模块-方法">
        <template slot-scope="{ row }">
          {{ row.testmoudle }}-{{ row.testmethod }}
        </template>
      </el-table-column>
      <el-table-column
        min-width="60"
        label="判定值">
        <template slot-scope="{ row }">
          {{ row.symbol }}{{ row.cov }}{{ row.covunit }}
        </template>
      </el-table-column>
      <el-table-column
        label="判定标准"
        min-width="140"
        prop="standnum"></el-table-column>
      <el-table-column
        label="检测结果值"
        min-width="90"
        prop="testresult"></el-table-column>
      <el-table-column
        label="判定结果"
        min-width="90"
        prop="decisionoutcome"></el-table-column>
      <el-table-column
        label="检测人员"
        width="100"
        prop="inspector"></el-table-column>
      <!-- <el-table-column
        label="检测地点"
        width="160"
        prop="testsite"></el-table-column> -->
      <el-table-column
        label="检测时间"
        min-width="135"
        prop="testingtime">
        <template slot-scope="{ row }">
          {{ row.testingtime | dateformat() }}
        </template>
      </el-table-column>
    </el-table>
    <report-modal
      ref="report"
      :callback="callback" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ReportModal from './report-modal.vue'
import EntAutoSelect from '../../../components/ent-auto-select.vue'
export default {
  name: 'UnReportedTable',
  components: { ReportModal, EntAutoSelect },
  data() {
    return {
      loading: true,
      list: [],
      config: {
        pageNum: 1,
        pageSize: 10000,
        statusList: [0]
      },
      multipleSelection: []
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    callback() {
      this.$refs.table.clearSelection()
      this.handleCurrentChange(1)
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getinspectiondatas', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    generateinspectionreport() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请勾选检测记录')
        return
      }
      console.log(this.multipleSelection)
      const map = {}
      const ids = []
      this.multipleSelection.forEach(i => {
        ids.push(i.inspectionItemDataId)
        const key = i.vendorId + '_' + i.productId
        if (!map[key]) {
          map[key] = {
            ...i,
            items: []
          }
        }
        map[key].items.push(i)
      })
      console.log(Object.values(map))
      this.$refs.report.init({
        list: Object.values(map),
        ids
      })
    }
  }
}
</script>
